export default "__VITE_ASSET__DYdMF9qa__"